import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actionsRolesList from './_redux/rolesActions';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

const DropdownRoles = ({ select = undefined, selected, setSelected }) => {
    const [change, setChange] = useState(false);
    const toast = useRef(null);
    const dispatch = useDispatch();
    const { rolesList, listLoading, error } = useSelector(
        state => state.roles,
        shallowEqual
    );
    useEffect(() => {
        if (!rolesList && !error) {
            dispatch(actionsRolesList.fetchRolesList({}));
        };
    }, [rolesList, error, dispatch]);
    useEffect(() => {
        if (error) {
            toast.current.show({ severity: 'error', summary: 'Genders', detail: error });
        };
    }, [error]);
    return (
        <div>
            <Toast ref={toast} position="bottom-right" />
            {select && !change ?
                <div className="p-inputgroup">
                    <InputText value={select} disabled />
                    <Button icon="pi pi-pencil" style={{ color: 'white' }} className="p-button-warning" onClick={() => setChange(true)} type="button" />
                </div>
                :
                !rolesList && listLoading ?
                    <div className="p-d-flex p-jc-center">
                        <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="8" animationDuration="3s" />
                    </div>
                    :
                    <div className="p-d-flex p-flex-row">
                        <Dropdown className={select ? "p-col-10" : "p-col-12"} optionLabel="ds_name" optionValue="id_type_of_role" value={selected}
                            options={rolesList}
                            onChange={(e) => setSelected(e.value)}
                            placeholder="Select a rol"
                        />
                        {select &&
                            <Button icon="pi pi-times" className="p-button-danger"
                                onClick={() => {
                                    setSelected(0);
                                    setChange(false);
                                }}
                                type="button"
                                tooltip="Cancel"
                            />
                        }
                    </div>
            }
        </div>
    )
}


export default DropdownRoles
